import axios from 'axios';

import apiPaths from 'enums/apiPaths';

// Post metoda pro volani loginu, ktera nam vraci token jako string
const restoreTokenApi = () => {
    return axios({
        method: 'GET',
        url: apiPaths.RESTORE_TOKEN
    });
};

export default restoreTokenApi;
